//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      selectedIndex: 0,
      tabListShow: false
    };
  },
  props: ['standardList', 'standShape', 'onlineStateList', 'type']
};